import axios from 'axios'
import auth from '@/services/auth.js'

// create an axios instance

const service = axios.create({
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json'
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    let token = auth.getToken()
    let info = JSON.parse(atob(token))
    // Do something before request is sent
    if (token) {
      config.headers['Token'] = info.token
    }
    return config
  }
)


// response interceptor
service.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },
  // error => error
  error => {
    let res = error.response
    if (res.status === 403 || res.status === 401) {
      auth.deleteToken()
      window.location.href = '/'
    }
    return Promise.reject(res)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/services/request.js